import $axios from './api';

export const create = async ( payload ) => {
	const { data } = await $axios.post('/v1/author/campaign/create', payload);
	return data;
};